import { UniformSlot } from "@uniformdev/canvas-react";
import { ManifestErrorMessage } from "src/uniform/utils/manifest-error-message";
import { useWAEContextSafe } from "src/uniform/utils/wae-context-provider";

import { Experiment, experiments } from "@/utils/experiment";
import { useExperiment } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";

export interface UniformExperimentProps {
    experimentId: string;
    postExperimentationMode?: boolean;
    override?: "control" | "treatment";
}

const UniformExperiment = (props: UniformExperimentProps) => {
    const { experimentId, override, postExperimentationMode } = props;

    const context = useWAEContextSafe();

    if (postExperimentationMode) {
        return (
            <FeatureExposed experimentKey={experimentId} group="Test">
                <UniformSlot name="treatment" />
            </FeatureExposed>
        );
    }

    const experiment = Object.entries(experiments).find(
        ([, value]) => value.experimentName === experimentId
    )?.[1];

    if (override && context?.wacEnvironment !== "production") {
        return <UniformSlot name={override} />;
    }

    if (!experiment) {
        return context?.wacEnvironment === "production" ? (
            <UniformSlot name="control" />
        ) : (
            <>
                <ManifestErrorMessage id={experimentId} />
                <UniformSlot name="control" />
            </>
        );
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const experimentStatus = useExperiment(experiment as Experiment<unknown>);

    const showTreatment =
        experimentStatus.type === "enrolled" && experimentStatus.value;

    return <UniformSlot name={showTreatment ? "treatment" : "control"} />;
};

export default UniformExperiment;
